import type { VotePayload } from '../models/vote.model';

// a vote the user actually saved. The server hands back a blank one for teams they haven't scored, and the score card
// writes picks into it before they're submitted, so its scores say nothing; only `saved` does
export const isSavedVote = (v: VotePayload) =>
    v.saved !== undefined
        ? v.saved
        : !!v._id && v._id !== '0' && ((v.scores || []).some(s => s > 0) || (v.answered || []).some(Boolean));
